"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const atome_1 = require("../../atome");
const react_native_1 = require("react-native");
const Checkbox_style_1 = require("./Checkbox.style");
function Checkbox({ checked, label, disabled = false, onPress, }) {
    let icon;
    if (checked) {
        icon = react_1.default.createElement(atome_1.Icon, { icon: 'checked' });
    }
    else {
        icon = react_1.default.createElement(atome_1.Icon, { icon: 'unchecked' });
    }
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, style: Checkbox_style_1.styles.row, disabled: disabled, onPress: () => onPress() },
        icon,
        react_1.default.createElement(atome_1.Text, { style: [Checkbox_style_1.styles.text] }, label)));
}
exports.Checkbox = Checkbox;
